<template>
  <div>
    <el-row class="top-container">
      <el-col :span="6"
              align="left">
        <div class="rocket-container">
          <el-progress id="rocket"
                       type="circle"
                       :width="100"
                       :height="100"
                       :stroke-width="5"
                       :color="colors"
                       :show-text="false"
                       :percentage=percent></el-progress>
          <img src="~/assets/pics/rocket.png"
               v-bind:class="runStatus?'':'not-running'"
               alt="" />
          <img v-if="imgIndex===0"
               v-bind:class="runStatus?'':'not-running'"
               src="~/assets/pics/flame1.png"
               alt="" />
          <img v-if="imgIndex===1"
               v-bind:class="runStatus?'':'not-running'"
               src="~/assets/pics/flame2.png"
               alt="" />
        </div>
      </el-col>
      <el-col :span="12"
              align="center">
        <div class="info-container">
          <div class="info-title">{{languages.PcOptimize.optimize}}</div>
          <div class="info-desc">{{languages.PcOptimize.desc}}</div>
        </div>
      </el-col>
      <el-col :span="6"
              align="right">
        <el-button class="scan-button"
                   type="primary"
                   :disabled="runStatus || !isToolReady"
                   :class="runStatus || !isToolReady?'is-disable':''"
                   @click="runOperate">
          {{operateStep==='check'?languages.PcOptimize.scan:languages.PcOptimize.clean}}
        </el-button>
      </el-col>
    </el-row>
    <div class="status-container">
      <el-checkbox :indeterminate="isAllIndeterminate"
                   v-model="checkAll"
                   @change="handleCheckAll"
                   :disabled="!isChecked"
                   class="system-check-all">{{languages.PcOptimize.all}}</el-checkbox>
      <span class="check-tips">{{languages.PcOptimize.tips}}</span>

      <div class="check-title">
        <el-checkbox :indeterminate="isSystemIndeterminate"
                     v-model="checkSystemAll"
                     :disabled="!isChecked"
                     @change="handleSystemCheckAll"></el-checkbox>
        <span class="title-info">
          {{languages.PcOptimize.systemFile}}
          <span v-if="systemTotalSize > 0">
            ({{languages.PcOptimize.release}}：{{Math.round(systemTotalSize / 102.4) / 10.0}} MB)
          </span>
        </span>

      </div>
      <div class="check-container">
        <el-checkbox-group v-model="checkedSystemOpList"
                           @change="handleSystemOpListChange">
          <el-checkbox v-for="sop in systemOpList"
                       :label="sop"
                       :key="sop.name"
                       :disabled="sop.size === undefined || sop.size === null"
                       class="check-item">{{sop.desc}}
            <span class="size-item">
              <i class="el-icon-check"
                 v-if="sop.cleaned === true"></i>
              <i class="el-icon-check"
                 v-if="sop.cleaned === false"></i>
            </span>
            <span class="size-item"
                  v-if="sop.size!=null && sop.size >= 0 && operateStep==='clean'">
              {{sop.size}} KB
            </span>
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <div class="check-title">
        <el-checkbox :indeterminate="isUserIndeterminate"
                     v-model="checkUserAll"
                     :disabled="!isChecked"
                     @change="handleUserCheckAll"></el-checkbox>
        <span class="title-info">
          {{languages.PcOptimize.userFile}}
          <span v-if="userTotalSize > 0">
            ({{languages.PcOptimize.release}}：{{Math.round(userTotalSize / 102.4) / 10.0}} MB)
          </span>
        </span>

      </div>
      <div class="check-container">
        <el-checkbox-group v-model="checkedUserOpList"
                           @change="handleUserOpListChange">
          <el-checkbox v-for="sop in userOpList"
                       :label="sop"
                       :key="sop.id"
                       :disabled="sop.size === undefined || sop.size === null"
                       class="check-item">{{sop.desc}}
            <span class="size-item">
              <i class="el-icon-check"
                 v-if="sop.cleaned === true"></i>
              <i class="el-icon-check"
                 v-if="sop.cleaned === false"></i>
            </span>
            <span class="size-item"
                  v-if="sop.size!=null && sop.size >= 0  && operateStep==='clean'">
              {{sop.size}} KB
            </span>
          </el-checkbox>

        </el-checkbox-group>
      </div>
    </div>
    <info-dialog :languages="languages"
                 :type="infoType"
                 :confirm="infoConfirm"
                 :show="dialogInfoVisible"
                 :tips="infoTips"
                 :submitting="submitting"></info-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import tools from 'common/tools';
import socket from 'common/socket';
import { ubtRegister, ubtSendTrace } from '../../utils/ubt';

export default {
  inject: ['homeTemplate'],
  components: {
    InfoDialog,
  },
  data () {
    return {
      dialogInfoVisible: false,
      infoTips: {},
      infoType: 'info',
      submitting: false,
      infoConfirm: false,
      isToolReady: false,
      operateStep: 'check',
      toolInfo: '',
      encryptPath: '',
      toolKey: '',
      colors: '#0080ff',
      isChecked: false,
      percent: 0,
      imgIndex: 0,
      rocketInterval: '',
      runStatus: false,
      checkAll: false,
      checkSystemAll: false,
      checkUserAll: false,
      systemTotalSize: 0,
      userTotalSize: 0,
      systemOpList: [],
      userOpList: [],
      checkedSystemOpList: [],
      checkedUserOpList: [],
      isAllIndeterminate: false,
      isSystemIndeterminate: false,
      isUserIndeterminate: false,
      totalCleaned: 0,
      toolRes: '',
      pvId: '',
    };
  },
  watch: {
    languages () {
      this.resetData();
      this.operateStep = 'check';
      this.systemOpList = this.languages.PcOptimize.systemOpList;
      this.userOpList = this.languages.PcOptimize.userOpList;
    },
  },
  computed: {
    ...mapState([
      'debugMode',
      'languages',
      'toolList',
      'userInfo',
      'deviceName',
      'isNewService',
    ]),
  },
  methods: {
    ...mapMutations([
      'setDebugData',
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setErrorType',
      'setErrorTips',
    ]),
    ...mapActions([
      'softwareInstall',
      'saveLog',
    ]),
    hideInfoDialog () {
      this.runStatus = false;
      this.resetData();
      this.dialogInfoVisible = false;
    },
    showDialog (title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
    },
    handleCheckAll (val) {
      if (val) {
        this.handleSystemCheckAll(true);
        this.handleUserCheckAll(true);
        this.checkSystemAll = true;
        this.checkUserAll = true;
        this.isToolReady = true;
        ubtSendTrace(245694, 'optimize_pc', 'check', 'SelectAll', '', '', this.pvId);
      } else {
        this.checkedSystemOpList = [];
        this.checkedUserOpList = [];
        this.handleSystemCheckAll(false);
        this.handleUserCheckAll(false);
        this.checkSystemAll = false;
        this.checkUserAll = false;
        this.isToolReady = false;
        ubtSendTrace(245694, 'optimize_pc', 'check', 'UnSelectAll', '', '', this.pvId);
      }
      this.isAllIndeterminate = false;
    },
    checkToolReady () {
      this.isToolReady = !((this.checkedSystemOpList.length === 0
        && this.checkedUserOpList.length === 0));
    },
    handleSystemCheckAll (val) {
      this.checkedSystemOpList = val ? this.systemOpList : [];
      if (val) {
        this.checkedSystemOpList = this.systemOpList;
        let totalCount = 0;
        this.systemOpList.forEach((item) => {
          totalCount += parseFloat(item.size);
        });
        this.systemTotalSize = totalCount;
        // 系统清理项全选
        ubtSendTrace(245694, 'optimize_pc', 'check', 'SystemSelectAll', '', '', this.pvId);
      } else {
        this.systemTotalSize = 0;
        this.checkedSystemOpList = [];
        // 系统清理项取消全选
        ubtSendTrace(245694, 'optimize_pc', 'check', 'UnSystemSelectAll', '', '', this.pvId);
      }
      this.isSystemIndeterminate = false;
      this.handleAllOpListChange();
    },
    handleUserCheckAll (val) {
      this.checkedUserOpList = val ? this.userOpList : [];
      if (val) {
        this.checkedUserOpList = this.userOpList;
        let totalCount = 0;
        this.userOpList.forEach((item) => {
          totalCount += parseFloat(item.size);
        });
        ubtSendTrace(245694, 'optimize_pc', 'check', 'UserSelectAll', '', '', this.pvId);
        this.userTotalSize = totalCount;
      } else {
        this.userTotalSize = 0;
        this.checkedUserOpList = [];
        ubtSendTrace(245694, 'optimize_pc', 'check', 'UnUserSelectAll', '', '', this.pvId);
      }
      this.isUserIndeterminate = false;
      this.handleAllOpListChange();
    },
    handleAllOpListChange () {
      const checkedCount = this.checkedSystemOpList.length + this.checkedUserOpList.length;
      const totalCount = this.systemOpList.length + this.userOpList.length;
      this.checkAll = checkedCount === totalCount;
      this.isAllIndeterminate = (checkedCount > 0 && checkedCount !== totalCount);
      this.checkToolReady();
    },
    handleSystemOpListChange (val) {
      ubtSendTrace(245694, 'optimize_pc', 'check', val, 'SystemCheck', '', this.pvId);
      let totalCount = 0;
      val.forEach((item) => {
        totalCount += parseFloat(item.size);
      });
      this.systemTotalSize = totalCount;
      const checkedCount = val.length;
      this.checkSystemAll = checkedCount === this.systemOpList.length;
      this.isSystemIndeterminate = checkedCount > 0 && checkedCount < this.systemOpList.length;
      this.isAllIndeterminate = checkedCount > 0 && checkedCount < this.systemOpList.length;
      this.handleAllOpListChange();
    },
    handleUserOpListChange (val) {
      ubtSendTrace(245694, 'optimize_pc', 'check', val, 'UserCheck', '', this.pvId);
      let totalCount = 0;
      val.forEach((item) => {
        totalCount += parseFloat(item.size);
      });
      this.userTotalSize = totalCount;
      const checkedCount = val.length;
      this.checkUserAll = checkedCount === this.userOpList.length;
      this.isUserIndeterminate = checkedCount > 0 && checkedCount < this.userOpList.length;
      this.isAllIndeterminate = checkedCount > 0 && checkedCount < this.userOpList.length;
      this.handleAllOpListChange();
    },
    resetRocket () {
      clearInterval(this.rocketInterval);
      setTimeout(() => {
        this.percent = 0;
      }, 100);
    },
    runOperate () {
      this.runStatus = true;
      this.runRocket();
      if (this.operateStep === 'check') {
        this.resetData();
        this.operateStep = 'clean';
        this.getSystemCheckData(() => {
          this.getUserCheckData(() => {
            this.runStatus = false;
          });
        });
        // 一键扫描埋点
        ubtSendTrace(245694, 'optimize_pc', 'scan', '', '', '', this.pvId);
      } else {
        this.operateStep = 'check';
        this.isChecked = false;
        if (this.checkedSystemOpList.length === 0) {
          if (this.checkedUserOpList.length > 0) {
            this.getCleanData('user', () => {
              this.cleanFinish();
            });
          }
        } else {
          this.getCleanData('system', () => {
            if (this.checkedUserOpList.length > 0) {
              this.getCleanData('user', () => {
                this.cleanFinish();
              });
            } else {
              this.cleanFinish();
            }
          });
        }
        // 一键清理埋点
        let systemText = 'SystemSelectAll';
        let userText = 'UserSelectAll';
        if (!this.checkSystemAll) {
          systemText = JSON.stringify(this.checkedSystemOpList);
        }
        if (!this.checkUserAll) userText = JSON.stringify(this.checkedUserOpList);
        ubtSendTrace(
          245694,
          'optimize_pc',
          'clear',
          systemText + userText,
          '',
          'selfhelp',
          this.pvId,
        );
      }
    },
    runRocket () {
      this.percent = 50;
      let delay = 0;
      this.rocketInterval = setInterval(() => {
        if (!this.runStatus) this.resetRocket();
        if (this.percent === 100) {
          delay = 1;
          setTimeout(() => {
            this.percent = 0;
          }, 400);
          setTimeout(() => {
            delay = 0;
          }, 800);
        } else if (delay === 0) this.percent += 50;
        this.imgIndex = this.imgIndex === 0 ? 1 : 0;
      }, 200);
    },
    cleanFinish () {
      this.resetRocket();
      this.showDialog(this.languages.note,
        `${this.languages.PcOptimize.finish.replace('SIZE', Math.round(this.totalCleaned / 102.4) / 10.0)}`);
      this.saveLog({
        title: 'PcOptimize',
        lan: this.languages.lan,
        target: 'handle clean',
        description: 'Success',
      });
    },
    resetData () {
      this.systemTotalSize = 0;
      this.userTotalSize = 0;
      this.totalCleaned = 0;
      this.checkedSystemOpList = [];
      this.checkedUserOpList = [];
      this.systemOpList.forEach((item, index) => {
        const newData = this.systemOpList[index];
        newData.cleaned = null;
        newData.size = null;
        this.systemOpList.splice(index, 1, newData);
      });
      this.userOpList.forEach((item, index) => {
        const newData = this.userOpList[index];
        newData.cleaned = null;
        newData.size = null;
        this.userOpList.splice(index, 1, newData);
      });
      this.checkAll = false;
      this.checkSystemAll = false;
      this.checkUserAll = false;
      this.isAllIndeterminate = false;
      this.isSystemIndeterminate = false;
      this.isUserIndeterminate = false;
    },
    async getSystemCheckData (cb) {
      if (this.isNewService) {
        for (let index = 0; index < this.systemOpList.length; index += 1) {
          const item = this.systemOpList[index];
          // eslint-disable-next-line no-await-in-loop
          await this.getCheckData(item.check, (rt) => {
            try {
              this.systemOpList[index].size = rt.datas.size;
            } catch (error) {
              this.systemOpList[index].size = 0;
            }
            this.checkedSystemOpList.push(this.systemOpList[index]);
            this.isAllIndeterminate = true;
            this.isSystemIndeterminate = true;
            if ((index + 1) === this.systemOpList.length) {
              this.checkSystemAll = true;
              this.isSystemIndeterminate = false;
              cb();
            }
            if (rt.datas.size) { this.systemTotalSize += parseFloat(rt.datas.size); }
          });
        }
      } else {
        let countIndex = 0;
        this.systemOpList.forEach((item) => {
          this.getCheckData(item.check, (rt) => {
            try {
              this.systemOpList[countIndex].size = rt.datas.size;
            } catch (error) {
              this.systemOpList[countIndex].size = 0;
            }
            this.checkedSystemOpList.push(this.systemOpList[countIndex]);
            this.isAllIndeterminate = true;
            this.isSystemIndeterminate = true;
            if ((countIndex + 1) === this.systemOpList.length) {
              this.checkSystemAll = true;
              this.isSystemIndeterminate = false;
              cb();
            }
            if (rt.datas.size) { this.systemTotalSize += parseFloat(rt.datas.size); }
            countIndex += 1;
          });
        });
      }
    },
    async getUserCheckData (cb) {
      if (this.isNewService) {
        for (let index = 0; index < this.userOpList.length; index += 1) {
          const item = this.userOpList[index];
          // eslint-disable-next-line no-await-in-loop
          await this.getCheckData(item.check, (rt) => {
            try {
              this.userOpList[index].size = rt.datas.size;
            } catch (error) {
              this.userOpList[index].size = 0;
            }
            this.checkedUserOpList.push(this.userOpList[index]);
            this.isAllIndeterminate = true;
            this.isUserIndeterminate = true;
            if ((index + 1) === this.userOpList.length) {
              this.isUserIndeterminate = false;
              this.checkUserAll = true;
              this.isAllIndeterminate = false;
              this.checkAll = true;
              this.isChecked = true;
              cb();
            }
            if (rt.datas.size) { this.userTotalSize += parseFloat(rt.datas.size); }
          });
        }
      } else {
        let countIndex = 0;
        this.userOpList.forEach((item) => {
          this.getCheckData(item.check, (rt) => {
            try {
              this.userOpList[countIndex].size = rt.datas.size;
            } catch (error) {
              this.userOpList[countIndex].size = 0;
            }
            this.checkedUserOpList.push(this.userOpList[countIndex]);
            this.isAllIndeterminate = true;
            this.isUserIndeterminate = true;
            if ((countIndex + 1) === this.userOpList.length) {
              this.isUserIndeterminate = false;
              this.checkUserAll = true;
              this.isAllIndeterminate = false;
              this.checkAll = true;
              this.isChecked = true;
              cb();
            }
            if (rt.datas.size) { this.userTotalSize += parseFloat(rt.datas.size); }
            countIndex += 1;
          });
        });
      }
    },
    async getCleanData (type, cb) {
      if (!this.isNewService) {
        if (type === 'system') {
          this.getSystemCleanData(cb);
        } else {
          this.getUserCleanData(cb);
        }
      } else {
        const checkList = type === 'system' ? this.checkedSystemOpList : this.checkedUserOpList;
        const opList = type === 'system' ? this.systemOpList : this.userOpList;
        for (let i = 0; i < checkList.length; i += 1) {
          const item = checkList[i];
          // eslint-disable-next-line no-await-in-loop
          await this.getCheckData(item.clean, (rt) => {
            this.totalCleaned += rt.datas.cleaned;
            const checkName = rt.datas.name;
            const index = opList.findIndex((itm) => (itm.check.indexOf(checkName) > -1));
            // for v-for dom reresh
            const newData = opList[index];
            newData.cleaned = rt.datas.result === 'success';
            opList.splice(index, 1, newData);
            if ((i + 1) === checkList.length) {
              cb();
            }
            // i += 1;
          });
        }
      }
    },
    async getCheckData (command, callback) {
      if (!this.isNewService) {
        const commandData = {
          lan: 'tools',
          type: 'littletools',
          username: `${this.userInfo.username}◎${command}`,
          softid: this.toolInfo[0].id,
          path: this.encryptPath,
          key: this.toolKey,
        };
        const socketDatas = tools.toUnicode(JSON.stringify(commandData));
        socket.sendSocket(0, `idesk_toolrun(${socketDatas})`, (rt) => {
          callback(rt);
        });
      } else {
        const toolData = {
          lan: 'tools',
          type: 'silent',
          username: `${this.userInfo.username}◎${command}`,
          softid: this.toolInfo[0].id,
          path: this.encryptPath,
          key: this.toolKey,
        };
        const socketDatas = tools.toUnicode(JSON.stringify(toolData));
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        let checkDone = false;
        await socket.sendSocket(2, runCmd, async (rt) => {
          const rst = JSON.parse(rt);
          if (rst.data === 'Tool Exited') {
            checkDone = true;
            const result = { datas: JSON.parse(rst.info) };
            callback(result);
          }
        });
        for (let i = 0; i < 100; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          if (!checkDone) await tools.sleep(100);
        }
      }
    },
    getSystemCleanData (cb) {
      let countIndex = 0;
      this.checkedSystemOpList.forEach((item) => {
        this.getCleanDataOld(item.clean, (rt) => {
          this.totalCleaned += rt.datas.cleaned;
          const checkName = rt.datas.name;
          const index = this.systemOpList.findIndex((itm) => (itm.check.indexOf(checkName) > -1));
          // for v-for dom reresh
          const newData = this.systemOpList[index];
          newData.cleaned = rt.datas.result === 'success';
          this.systemOpList.splice(index, 1, newData);
          if ((countIndex + 1) === this.checkedSystemOpList.length) {
            cb();
          }
          countIndex += 1;
        });
      });
    },
    getUserCleanData (cb) {
      let countIndex = 0;
      this.checkedUserOpList.forEach((item) => {
        this.getCleanDataOld(item.clean, (rt) => {
          this.totalCleaned += rt.datas.cleaned;
          const checkName = rt.datas.name;
          const index = this.userOpList.findIndex((itm) => (itm.check.indexOf(checkName) > -1));
          // for v-for dom refresh
          const newData = this.userOpList[index];
          newData.cleaned = rt.datas.result === 'success';
          this.userOpList.splice(index, 1, newData);
          if ((countIndex + 1) === this.checkedUserOpList.length) {
            cb();
          }
          countIndex += 1;
        });
      });
    },
    getCleanDataOld (command, callback) {
      const commandData = {
        lan: 'tools',
        type: 'littletools',
        username: `${this.userInfo.username}◎${command}`,
        softid: this.toolInfo[0].id,
        path: this.encryptPath,
        key: this.toolKey,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(commandData));
      socket.sendSocket(0, `idesk_toolrun(${socketDatas})`, (rt) => {
        callback(rt);
      });
    },
    async runTool () {
      // local tool check
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`PcOptimize > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'PcOptimize > softwareInstall',
          description: res.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      this.encryptPath = res.data.encryptPath;
      this.toolKey = res.data.key;
      const toolData = {
        lan: 'tools',
        type: 'littletools',
        username: this.userInfo.username,
        softid: this.toolInfo[0].id,
        path: this.encryptPath,
        key: this.toolKey,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(toolData));
      socket.sendSocket(0, `idesk_toolcheck(${socketDatas})`, (rst) => {
        if (rst.result !== 'match') {
          this.setErrorTips(`PcOptimize > toolCheck > ${rst.error_msg}`);
          this.saveLog({
            title: 'toolcheck_error',
            lan: 'tools',
            target: 'PcOptimize > toolcheck',
            description: rst.error_msg,
          });
          this.setErrorType('apierror');
          this.$router.push('/error');
        } else {
          this.isToolReady = true;
        }
      });
    },
  },
  async created () {
    this.setPageNow('PcOptimize');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.toolInfo = this.toolList.filter(
      (item) => item.name.indexOf('PcOptimize') !== -1,
    );
    if (this.toolInfo.length !== 1) {
      this.setErrorTips('PcOptimize > getToolInfo > No such little tool');
      this.saveLog({
        title: 'api_error',
        lan: this.languages.lan,
        target: 'PcOptimize > getToolInfo',
        description: 'No such little tool!',
      });
      this.setErrorType('apierror');
      this.$router.push('/error');
      return;
    }
    if (this.isNewService) {
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`PcOptimize > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'PcOptimize > softwareInstall',
          description: res.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      this.encryptPath = res.data.encryptPath;
      this.toolKey = res.data.key;
      this.homeTemplate.downToolNew('PcOptimize', this.toolInfo[0].id, res, async () => {
        this.isToolReady = true;
      });
    } else {
      this.runTool();
    }
    this.systemOpList = this.languages.PcOptimize.systemOpList;
    this.userOpList = this.languages.PcOptimize.userOpList;
    this.pvId = ubtRegister('Pc Optimize');
  },
};
</script>

<style lang="scss" scoped>
.top-container {
  margin: 20px;
  background-color: #f0f2f5;
  border-radius: 15px;
  height: 130px;
  .rocket-container {
    margin-top: 15px;
    margin-left: 50px;
    width: 100px;
    position: relative;
    img {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
    }
  }
  .info-container {
    height: 130px;
    .info-title {
      height: 60px;
      line-height: 60px;
      margin-top: 20px;
      font-size: 30px;
    }
  }
  .scan-button {
    height: 50px;
    line-height: 50px;
    margin-top: 40px;
    margin-right: 50px;
    font-size: 16px;
    width: 130px;
    height: 50px;
  }
}

.status-container {
  position: absolute;
  top: 220px;
  bottom: 0;
  left: 0;
  right: 0;
  .system-check-all {
    margin: 15px 20px;
    padding: 0 10px;
  }
  .check-tips {
    font-size: 14px;
    color: #0080ff;
  }
  .check-title {
    margin: 10px 20px;
    padding: 5px 30px;
    background-color: #f0f2f5;
    border-radius: 5px;
    i {
      color: #1466de;
      margin-left: 10px;
      margin-right: 20px;
      cursor: pointer;
    }
    .title-info {
      margin-left: 10px;
      span {
        margin-left: 5px;
        font-size: 14px;
        color: #0080ff;
      }
    }
  }
  .check-container {
    display: flex;
    flex-direction: column;
    .check-item {
      margin: 5px 75px;
      display: block;
      span {
        font-size: 12px;
        margin-left: 20px;
        opacity: 0.7;
      }
    }
    .el-icon-check {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.not-running {
  opacity: 0.5;
}
.is-disable {
  background-color: #999 !important;
  border: none !important;
}
.size-item {
  color: #0080ff;
}
</style>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #0080ff !important;
  background-color: #0080ff !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000 !important;
}
.el-checkbox__inner:hover {
  border-color: #0080ff !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #0080ff !important;
}
</style>
